import {
  AppstoreOutlined,
  BarChartOutlined,
  BugOutlined,
  BulbOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CreditCardOutlined,
  CrownOutlined,
  DesktopOutlined,
  FileTextOutlined,
  FireOutlined,
  FormOutlined,
  FundOutlined,
  HomeOutlined,
  IdcardOutlined,
  LineChartOutlined,
  OrderedListOutlined,
  PictureOutlined,
  ProfileOutlined,
  ProjectOutlined,
  RadarChartOutlined,
  ReadOutlined,
  RobotOutlined,
  SettingOutlined,
  StopOutlined,
  TableOutlined,
  UnorderedListOutlined,
  UserAddOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { createElement } from 'react';

const menuIconMap = {
  appstore: AppstoreOutlined,
  barChart: BarChartOutlined,
  bug: BugOutlined,
  bulb: BulbOutlined,
  checkCircle: CheckCircleOutlined,
  closeCircle: CloseCircleOutlined,
  creditCard: CreditCardOutlined,
  crown: CrownOutlined,
  desktop: DesktopOutlined,
  fileText: FileTextOutlined,
  fire: FireOutlined,
  form: FormOutlined,
  fund: FundOutlined,
  home: HomeOutlined,
  idcard: IdcardOutlined,
  lineChart: LineChartOutlined,
  orderedList: OrderedListOutlined,
  picture: PictureOutlined,
  profile: ProfileOutlined,
  project: ProjectOutlined,
  radarChart: RadarChartOutlined,
  read: ReadOutlined,
  robot: RobotOutlined,
  setting: SettingOutlined,
  stop: StopOutlined,
  table: TableOutlined,
  unorderedList: UnorderedListOutlined,
  user: UserOutlined,
  userAdd: UserAddOutlined,
  warning: WarningOutlined,
};

const resolveMenuIcon = (icon) => {
  if (!icon) {
    return undefined;
  }
  if (typeof icon !== 'string') {
    return icon;
  }
  const Icon = menuIconMap[icon];
  return Icon ? createElement(Icon) : undefined;
};

const resolveRoutePath = (parentPath, currentPath) => {
  if (!currentPath) {
    return parentPath || undefined;
  }
  if (currentPath.startsWith('/')) {
    return currentPath;
  }
  const normalizedParent = parentPath && parentPath !== '/' ? parentPath.replace(/\/$/, '') : '';
  return `${normalizedParent}/${currentPath}`;
};

export const buildMenuData = (routes, options = {}) => {
  return routes
    .filter((route) => route.name && (options.includeHidden || route.hideInMenu !== true))
    .map((route) => {
      const path = resolveRoutePath(options.parentPath, route.path);
      return {
        path,
        name: route.name,
        ...(route.hideInMenu ? { hideInMenu: true } : {}),
        icon: resolveMenuIcon(route.icon),
        routes: route.children
          ? buildMenuData(route.children, { ...options, parentPath: path })
          : undefined,
      };
    });
};
